import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Camera } from 'lucide-react';

export const LandingScreen = ({ onStart }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#F5F5F5] overflow-hidden"
      data-testid="landing-screen"
    >
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 right-20 w-96 h-96 rounded-full bg-[#082BCC]/5 blur-3xl" />
        <div className="absolute bottom-20 left-20 w-96 h-96 rounded-full bg-[#082BCC]/5 blur-3xl" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        {/* Logo */}
        <motion.img
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          src="https://framerusercontent.com/images/Qx3N6D3xDD7B99tP20IHUhGs2U.png"
          alt="AI Plus Logo"
          className="h-16 mx-auto mb-12"
          data-testid="landing-logo"
        />

        {/* Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.3, type: 'spring', stiffness: 200 }}
          className="mb-8"
        >
          <Camera className="w-20 h-20 mx-auto text-[#082BCC]" />
        </motion.div>

        {/* Heading */}
        <motion.h1
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.6 }}
          className="font-satoshi font-black text-5xl md:text-7xl tracking-tight leading-none text-[#1A1A1A] mb-6"
          data-testid="landing-heading"
        >
          We loved having you at<br />RenAIssance 2026
        </motion.h1>

        <motion.p
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.6 }}
          className="font-satoshi font-medium text-xl md:text-2xl text-[#666666] mb-12 leading-relaxed max-w-2xl mx-auto"
          data-testid="landing-description"
        >
          Relive the moments, download your favorite memories, and share the experience with your network.
        </motion.p>

        {/* CTA Button */}
        <motion.button
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.6 }}
          onClick={onStart}
          className="group relative inline-flex items-center gap-3 bg-[#082BCC] text-white font-satoshi font-bold text-lg px-12 py-6 rounded-xl overflow-hidden transition-all duration-300 hover:shadow-2xl hover:shadow-[#082BCC]/30"
          data-testid="landing-start-button"
        >
          <span className="relative z-10">Explore the Photos</span>
          <ArrowRight className="relative z-10 w-6 h-6 transition-transform duration-300 group-hover:translate-x-1" />
          
          {/* Hover effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#082BCC] to-[#0624a3] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        </motion.button>

        {/* Footer note */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.6 }}
          className="font-satoshi text-sm text-[#999999] mt-8"
          data-testid="landing-footer-note"
        >
          All photos available for download
        </motion.p>
      </div>
    </motion.div>
  );
};

export default LandingScreen;
